'use client';
import { useRef } from 'react';
import { Box } from '@wanteddev/wds-engine';
import { createRegionStore, RegionContext, useRegionStore } from '../stores/region-store.mjs';
import RegionStatus from '../components/region-status/index.mjs';
import { createDialogStore, DialogContext } from '../stores/dialog-store.mjs';
import Dialog from '../components/dialog/index.mjs';
import { jsx, jsxs } from 'react/jsx-runtime';

var StoreProvider = ({ children }) => {
  const regionStoreRef = useRef();
  const dialogStoreRef = useRef();
  if (!regionStoreRef.current) {
    regionStoreRef.current = createRegionStore();
  }
  if (!dialogStoreRef.current) {
    dialogStoreRef.current = createDialogStore();
  }
  return /* @__PURE__ */ jsx(DialogContext.Provider, { value: dialogStoreRef.current, children: /* @__PURE__ */ jsxs(RegionContext.Provider, { value: regionStoreRef.current, children: [
    children,
    /* @__PURE__ */ jsx(RegionStatus, {}),
    /* @__PURE__ */ jsx(RegionArea, {}),
    /* @__PURE__ */ jsx(Dialog, {})
  ] }) });
};
var store_provider_default = StoreProvider;
var RegionArea = () => {
  const config = useRegionStore((state) => state.config);
  return /* @__PURE__ */ jsx(
    Box,
    {
      "wds-ignore-dismissable-layer": "true",
      style: {
        "--wds-region-viewport-top": `calc(env(safe-area-inset-bottom, 0px) + ${config.viewportTop})`,
        "--wds-region-viewport-max-width": `calc(${config.viewportMaxWidth})`,
        "--wds-region-viewport-bottom": `calc(env(safe-area-inset-bottom, 0px) + ${config.viewportBottom})`
      },
      role: "region",
      "aria-live": "polite",
      id: "wds-region-manager",
      "aria-label": "Notifications",
      children: /* @__PURE__ */ jsx(
        Box,
        {
          id: "wds-region-manager-bottom",
          sx: (theme) => ({
            position: "fixed",
            gap: "14px",
            zIndex: 5500,
            justifyContent: "center",
            pointerEvents: "none",
            width: "fit-content",
            minWidth: "100px",
            alignItems: "center",
            display: "flex",
            flexDirection: "column",
            maxWidth: "var(--wds-region-viewport-max-width, 100%)",
            padding: "20px",
            left: "50%",
            transform: "translateX(-50%)",
            bottom: "var(--wds-region-viewport-bottom, 0px)",
            paddingBottom: "40px",
            [`@media (max-width: ${theme.breakpoint.sm})`]: {
              paddingBottom: "34px"
            }
          })
        }
      )
    }
  );
};

export { store_provider_default as default };
